<div class="text-center">
    <mat-icon>developer_board</mat-icon>
    <h1 mat-dialog-title translate> dialog.slotmodel.slot.title</h1>
  
    <div class="modal-body" mat-dialog-content>
  
        <help-alert text = "help.page.slot_model.slot_field" info = "help.info" description = "help.page.slot_model.slot_description"></help-alert>

        <div class="card container">
            <div class="row mt-2">
                <div class="col-sm">
                    <span translate>dialog.slotmodel.slot.timeFrom</span>
                    <ngb-timepicker [(ngModel)] = "time" (ngModelChange)="checkTime()"></ngb-timepicker>
                </div>
            </div>
        </div>

        <div class="card container mt-2">
            <div class="row mt-2">
                <div class="col-sm">
                    <mat-form-field>
                    <mat-label translate>dialog.slotmodel.slot.type</mat-label>
                    <mat-select [(ngModel)]="type" required matNativeControl>
                        <mat-option *ngFor="let element of list" [value]="element.id">
                        {{element.name}}
                        </mat-option>
                    </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm">
                    <mat-form-field class = "full-width">
                        <mat-label translate>dialog.slotmodel.slot.count</mat-label>
                        <input [(ngModel)]="count" (change)="checkCount($event)" type="number" [min]="1" [max]="60" matInput required>
                    </mat-form-field>
                </div>
            </div>
        </div>
 
      
    </div>
  
  
    <div class="modal-footer" mat-dialog-actions translate>

        <button type="button" class="btn btn-outline-danger" (click)="cancel()" translate>
        dialog.service.generic.cancel
        </button>

        <button type="button" class="btn btn-outline-secondary" (click)="confirm()"
        translate>
        dialog.service.update.confirm
        </button>


    </div>

</div>